import { initialState } from "./ricerca.state";
import * as ricercaAction from './ricerca.actions';
import { MorphologyTrait, SemanticGroupTextualForms, TextualForm } from "../interfaces/semantic-group-textual-forms.model";

export function ricercaReducer(state = initialState, action: ricercaAction.RicercaAction) {
    switch (action.type) {
        case ricercaAction.SET_QUERY_FORM: {
            return {
                ...state,
                queryForm: action.payload
            };
        };
        case ricercaAction.SET_SELECTED_RESOURCES: {
            return {
                ...state,
                selectedResources: action.payload
            };
        };
        case ricercaAction.GET_RESOURCE_TREE_SUCCESS: {
            return {
                ...state,
                resourceList: action.payload
            };
        };
        case ricercaAction.GET_POS_LIST_SUCCESS: {
            return {
                ...state,
                posList: action.payload
            };
        };
        case ricercaAction.GET_LEXICAL_SENSES_SUCCESS: {
            return {
                ...state,
                lexicalSenses: action.payload,
                queryForm: {
                    ...state.queryForm,
                    senses: []
                },
                morphTraitDialogVisible: false,
                morphTraitDialogPos: '',
                morphTraitDialogMus: null,
                selectedMorphList: []
            };
        };
        case ricercaAction.START_GET_ID_FORMS_LIST_FROM_TEMPLATE: {
            if (!state.totalLoadingStep || state.totalLoadingStep === 0) {
                return {
                    ...state,
                    totalLoadingStep: Math.ceil(action.payload.idList.length / 600)
                }
            } else {
                return {
                    ...state
                }
            }
        };
        case ricercaAction.GET_ID_FORMS_LIST_FROM_TEMPLATE_PARTIAL: {
            let temp = state.executedLoadingStep ? (state.executedLoadingStep + 1) : 1;
            console.log(temp);
            return {
                ...state,
                executedLoadingStep: temp
            };
        };
        case ricercaAction.CANCEL_GET_ID_FORMS_LIST_FROM_TEMPLATE: {
            return {
                ...state,
                totalLoadingStep: 0,
                executedLoadingStep: 0
            };
        };
        case ricercaAction.GET_FORMS_LIST_SUCCESS:
        case ricercaAction.GET_ID_FORMS_LIST_SUCCESS: {
            let test: SemanticGroupTextualForms[] = [];
                action.payload.response.forEach((f, i) => {
                    test.push({ ...f, targetLemma: f.target.length > 0 ? f.target[f.target.findIndex(e => e.formType === 'canonicalForm')]?.label : '' });
                });
            if (action.isFromTemplate) {
                return {
                    ...state,
                    formsList: [],
                    totalLoadingStep: 0,
                    executedLoadingStep: 0
                };
            }
            let tempFormsList: SemanticGroupTextualForms[] = ('response' in action.payload) ? [...action.payload.response] : [...action.payload];
            // console.log(tempFormsList);
            // tempFormsList.forEach((f, i) => {
            //     tempFormsList[i] = { ...tempFormsList[i], targetLemma: f.target.length > 0 ? f.target[f.target.findIndex(e => e.formType === 'canonicalForm')].label : '' };
            // });
            // if (state.queryForm.type === 'keyword') {
            //     let tempSGFilter: SemanticGroupTextualForms;
            //     tempFormsList.forEach((s, i) => {
            //         if (s.semanticRelation === '') {
            //             tempFormsList[i] = { ...tempFormsList[i], target: s.target.filter(t => t.label === state.queryForm.name) };
            //             tempSGFilter = { ...tempFormsList[i] };
            //         } else {
            //             let accumulatore: TextualForm[] = [];
            //             tempSGFilter.target.forEach(sourceFilter => { //ciclo sui target base sopravvissuti al filtro
            //                 accumulatore.push(...cleanFormsFromMorphology(sourceFilter.morphology, s.target));
            //             });
            //             tempFormsList[i] = { ...tempFormsList[i], target: [...accumulatore] };
            //         }
            //     });
            // }
            // if (state?.selectedMorphList && state.selectedMorphList.length > 0) { //se esistono delle regole morfologiche
            //     tempFormsList.forEach((s, i) => {
            //         let indexMorph = state.selectedMorphList.findIndex(m => m.mus === s.lexicalEntryInstanceName);
            //         if (s.semanticRelation === '' && indexMorph !== -1) {
            //             tempFormsList[i] = { ...tempFormsList[i], target: cleanForms(state.selectedMorphList[indexMorph], s.target) };
            //         } else if (s.semanticRelation !== '') {
            //             let parentMus = state.lexicalSenses.filter(ls => ls.senseInstanceName === s.senseInstanceName)[0].lexicalEntryInstanceName;
            //             let indexParentMorph = state.selectedMorphList.findIndex(pm => pm.mus === parentMus);
            //             if (indexParentMorph !== -1) {
            //                 tempFormsList[i] = { ...tempFormsList[i], target: cleanForms(state.selectedMorphList[indexParentMorph], s.target) };
            //             }
            //         }
            //         if (tempFormsList[i].target.length === 0) {
            //             tempFormsList.splice(i, 1);
            //         }
            //     })
            // }
            return {
                ...state,
                formsList: tempFormsList,
                totalLoadingStep: 0,
                executedLoadingStep: 0
            };
        };
        case ricercaAction.LEX_ENTRY_MODAL_VISIBILITY: {
            return {
                ...state,
                lexEntryDialogVisible: action.payload
            }
        };
        case ricercaAction.CREATE_LEXICAL_ENTRY_SUCCESS: {
            return {
                ...state,
                workingLexicalEntry: action.payload
            };
        };
        case ricercaAction.MORPH_TRAIT_MODAL_VISIBILITY: {
            return {
                ...state,
                morphTraitDialogVisible: action.payload.visible,
                morphTraitDialogPos: action.payload.pos,
                morphTraitDialogMus: action.payload.mus
            };
        };
        case ricercaAction.SAVE_MORPH_TRAIT: {
            let indexMorph = state.selectedMorphList ? state.selectedMorphList.findIndex(m => m.mus === action.payload.mus) : -1;
            let tempSelectedMorph: { mus: string, morph: any }[] = state.selectedMorphList ? [...state.selectedMorphList] : [];
            if (indexMorph === -1) {
                tempSelectedMorph.push({ mus: action.payload.mus, morph: action.payload.morph });
            } else {
                tempSelectedMorph[indexMorph] = { mus: action.payload.mus, morph: action.payload.morph };
            }
            return {
                ...state,
                selectedMorphList: tempSelectedMorph
            };
        };
        case ricercaAction.GET_OCCURRENCE_FROM_RESOURCE_SUCCESS: {
            return {
                ...state,
                occurrenceList: action.payload
            };
        };
        case ricercaAction.GET_SENSES_BY_CONCEPT_SUCCESS:
        case ricercaAction.GET_SENSES_BY_CONCEPT_2_SUCCESS: {
            return {
                ...state,
                sensesByConcept: action.payload.length > 0 ? [...action.payload] : []
            };
        };
        case ricercaAction.GET_ANALYZED_SENTENCE_SUCCESS: {
            return {
                ...state,
                analyzedSentence: action.payload
            };
        };
        case ricercaAction.SET_SELECTED_SENSES_BY_CONCEPT: {
            return {
                ...state,
                selectedSensesByConcept: action.payload
            };
        };
        case ricercaAction.CLEAN_LEXICAL_SENSES: {
            return {
                ...state,
                lexicalSenses: [],
                queryForm: {
                    ...state.queryForm,
                    senses: []
                }

            };
        };
        case ricercaAction.CLEAN_ON_EXIT: {
            return {
                ...initialState
            };
        };
        default: {
            return {
                ...state
            };
        }
    }
}

function cleanForms(morphRules: { mus: string, morph: any }, formList: TextualForm[]): TextualForm[] {
    let resultForms = [...formList];

    for (let key in morphRules.morph) {
        if (morphRules.morph[key] !== null && morphRules.morph[key].length > 0) {
            resultForms = resultForms.filter(r => {
                return r.morphology.findIndex(t => t.trait === key && morphRules.morph[key].includes(t.value)) !== -1;
            });
        }
    }

    return resultForms;
}

function cleanFormsFromMorphology(morphs: MorphologyTrait[], targetForms: TextualForm[]): TextualForm[] {
    let resultForms = [...targetForms];
    for (let morph of morphs) {
        if (morph.trait !== 'gender') {
            resultForms = resultForms.filter(r => {
                return r.morphology.findIndex(t => t.trait === morph.trait && morph.value === t.value) !== -1;
            })
        }
    }
    return resultForms;
}